<template>
    <div>
        <div class="search-box">
            <p>项目来源：</p>
            <a-input class="input-box"  v-model="searchFrom.sourceName"/>
            <p>下达部门：</p>
            <a-input class="input-box"  v-model="searchFrom.department"/>
            <p>项目级别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.projectLevel" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xmjbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>项目编码：</p>
            <a-input class="input-box"  v-model="searchFrom.projectNo"/>
            <p>项目名称：</p>
            <a-input class="input-box"  v-model="searchFrom.projectName"/>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button> -->
            <!-- <a-button type="primary" icon="import" class="right-btn" >批量导入</a-button> -->
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '200%' }"
            bordered>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <!-- <p class="table-tips">更新截至日期：{{lastTime}}</p> -->
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/research/project'
    import Info from './modules/projectInfo'
    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            fixed: 'left',
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '项目来源',
            dataIndex: 'sourceName',
            align:'center',
        },
        {
            title: '项目下达部门',
            dataIndex: 'department',
            align:'center',
        },
        {
            title: '项目级别',
            dataIndex: 'projectLevel',
            align:'center',
        },
        {
            title: '项目编码',
            dataIndex: 'projectNo',
            align:'center'
        },
        {
            title: '项目名称',
            dataIndex: 'projectName',
            ellipsis: true,
        },
        {
            title: '负责人',
            dataIndex: 'headerName',
            align:'center'
        },
        {
            title: '项目初始年月',
            dataIndex: 'startDate',
            width:150,
            align:'center'
        },
        {
            title: '项目结束年月',
            dataIndex: 'endDate',
            width:150,
            align:'center'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'id' },
            width:200,
            fixed: 'right',
        }

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    sourceName:'',
                    department:'',
                    projectLevel:'',
                    projectNo:'',
                    projectName:'',
                },
                xmjbArr:[],
            }
        },
        mounted () {
            getDicts({dataCode:'KYCG-XMJB',status:true}).then(res=>{
                this.xmjbArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            handSearch(value){
                if(value!=''){
                    this.searchFrom.consProjectTypeCode=value
                }
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除项目成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

</style>
